import { useAtom } from 'jotai';
import React, { useCallback } from 'react';

import { Flex, Pagination } from '~/components/blocks';
import { medicationFollowupNotificationPanelState } from '~/state/layouts/SharedAppShell/atoms';

import { NotificationPanelBase } from '../NotificationPanelBase';
import { NotificationList } from './NotificationList';

export const MedicationFollowupNotificationPanel = () => {
  const [{ totalCount, totalPage, page }, setMedicationFollowupNotificationPanelState] = useAtom(
    medicationFollowupNotificationPanelState,
  );

  const handleChange = useCallback(
    (page: number) =>
      setMedicationFollowupNotificationPanelState((_state) => ({ ..._state, page })),
    [setMedicationFollowupNotificationPanelState],
  );

  return (
    <NotificationPanelBase>
      <NotificationPanelBase.Content>
        <NotificationList />
      </NotificationPanelBase.Content>
      {totalCount > 0 && (
        <NotificationPanelBase.Footer>
          <Flex justifyContent="center">
            <Pagination currentPage={page} totalPage={totalPage} onChange={handleChange} />
          </Flex>
        </NotificationPanelBase.Footer>
      )}
    </NotificationPanelBase>
  );
};
